import gql from "graphql-tag";

const ANSWER_QUIZ_QUESTION = gql`
    mutation answerQuizQuestion (
        $poolId: String!
        $quizId: String!
        $questionId: String!
        $answerId: String!
    ) {
        answerQuizQuestion (
            answerPoolQuizQuestionInput: {
                poolId: $poolId
                quizId: $quizId
                questionId: $questionId
                answerId: $answerId
            }
        ) {
            id
            points
            isCorrect
            isLastQuestion
            nextQuestion {
                id
                orderNumber
                question
                answers {
                    id
                    orderNumber
                    answer
                }
            }
            quizTracker {
                id
                pool_id
                quiz_id
                user_id
                start_time
                end_time
                createdAt
                updatedAt
                isSuccessful
                score
                last_answered_question_id
            }
        }
    }
`

export default ANSWER_QUIZ_QUESTION;